import {
    useContext,
} from "react"

import "./style.css"

import { 
    Tab, 
    Nav, 
    Col, 
    Row, 
    Tooltip,
    OverlayTrigger,
} from "react-bootstrap"

import {
    IS_DEV
} from "../../../ViewModel/devUtils"

import styles from "../../Stylesheets/Navigation"
import {
    Context,
} from "../../../Model/Contexts/AppContext"

/**
 * This component will represent the vertical tab bar.
 *
 * @param props
 * @author  Andrew Berger
 * @since   1.0.0
 * @exports EMETLNavigator
 */
const EMETLNavigator = () => {
    const {
        header: {
            value: header,
        },
        pages: {
            value: PAGES,
        },
    } = useContext(Context)

    const DEFAULT_VIEW = "ViewAssessments"

    return (
        <>
            {header && (
                <div 
                    id="header"
                >
                    {header}
                </div>
            )}
            <div id="content" style={styles.content}>
                <Tab.Container defaultActiveKey={DEFAULT_VIEW} mountOnEnter unmountOnExit>
                    <Row style={styles.tabRow}>
                        <div style={styles.tabBarStyle}>
                            <Col sm={3}>
                                <Nav variant="pills" className="flex-column">
                                    {PAGES.map(({ name, icon, title }) => {
                                        return (
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip>
                                                        {title}
                                                    </Tooltip>
                                                }
                                                key={name}                                              

                                            >
                                                <Nav.Item>
                                                    <Nav.Link
                                                        id={name}
                                                        style={styles.tabLinkStyle}
                                                        eventKey={name}
                                                    >
                                                        { icon }
                                                    </Nav.Link>
                                                </Nav.Item>
                                            </OverlayTrigger>
                                        )
                                    })}
                                </Nav>
                            </Col>
                        </div>
                        <Col style={styles.tabContentWrapper}>
                            <div id="tabBarBackground" />
                            <Tab.Content
                                style={styles.content}
                            >
                                {PAGES.map(({ name, page, title, leftNavItem, rightNavItem }) => (
                                    <Tab.Pane
                                        eventKey={name}
                                        key={name}
                                        style={styles.tabContentPane}
                                    >
                                        <>
                                            <div
                                                id="headerContent"
                                            >
                                                <div
                                                    id="headerSubnav"
                                                >
                                                    <h1
                                                        className="text-secondary"
                                                        id="pageTitle"
                                                    >
                                                        {title}
                                                    </h1>
                                                    {leftNavItem && leftNavItem()}
                                                </div>
                                                <div>
                                                    {rightNavItem && rightNavItem()}
                                                </div>
                                            </div>
                                            {page}
                                        </>
                                    </Tab.Pane>
                                ))}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        </>
    )
}

export default EMETLNavigator